import moment from "moment";
import React from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  OverlayTrigger,
  Row,
  Tab,
  Tooltip,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Hourglass } from "react-loader-spinner";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { getAllInformasiDebitur } from "stores";
import Swal from "sweetalert2";
import Select from "react-select";
import DetailCalonNasabahIdeb from "./DetailCalonNasabahIdeb";

function InformasiDebitur() {
  const debiturReducer = useSelector((state) => state.informasiDebiturReducer);
  const dispatch = useDispatch();
  const [searchText, setSearchText] = React.useState("");
  const [pending, setPending] = React.useState(false);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [listIdeb, setListIdeb] = React.useState([]);
  const [idNasabah, setIdNasabah] = React.useState("");
  const [sendVal, setSendVal] = React.useState("");
  const handleFilterChange = () => {
    setPending(true);
    getAllInformasiDebitur(dispatch, {
      cari: searchText,
      page: page + 1,
      limit: totalPerHalaman,
    })
      .then((response) => {
        setPending(false);
      })
      .catch((error) => {
        setPending(false);
        Swal.fire({
          icon: "error",
          tile: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  const getTypeKunjungan = (status) => {
    switch (status) {
      case "konsumtif":
        return {
          fontWeight: "bold",
          backgroundColor: "#DDF3F4",
          textColor: "#0C8990",
        };
      case "produktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFF6E6",
          textColor: "#FFA700",
        };
      default:
        return {};
    }
  };

  const handleDetailsClick = (val) => {
    dispatch({ type: "SET_DETAIL_NASABAH_IDEB", data: false });
    setIdNasabah(val.idPemilikUsaha);
    setSendVal(val);
    // dispatch({ type: "SET_KIRIM_DETAIL_NASABAH", data: val });
  };

  React.useEffect(() => {
    setPending(true);
    getAllInformasiDebitur(dispatch, {
      cari: searchText,
      page: page + 1,
      limit: totalPerHalaman,
    })
      .then((response) => {
        setPending(false);
      })
      .catch((error) => {
        setPending(false);
        Swal.fire({
          icon: "error",
          tile: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [totalPerHalaman, page]);

  React.useEffect(() => {
    const data = debiturReducer?.listAllIdeb?.data;

    if (Array.isArray(data) && data.length > 0) {
      const tmp = data.map((val) => ({
        ...val,
        action: (
          <>
            {" "}
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Details </Tooltip>}
            >
              <Button
                className="mr-0"
                style={{
                  marginTop: 5,
                  backgroundColor: "#00BFFF",
                  border: 0,
                }}
                onClick={() => {
                  handleDetailsClick(val);
                }}
              >
                <i class="fas fa-info"></i>
              </Button>
            </OverlayTrigger>
          </>
        ),
      }));
      setListIdeb(tmp);
    }
  }, [debiturReducer.listAllIdeb && debiturReducer.listAllIdeb]);

  const colListIdeb = [
    {
      name: "No",
      width: "100px",
      center: true,
      // selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
      selector: (row, index) =>
        index + debiturReducer.listAllIdeb.pagingCounter,
    },
    {
      name: "BAP-LOAN",
      minWidth: "290px",
      center: true,
      selector: (row) => row.loan,
    },
    {
      name: "Id Nasabah",
      minWidth: "290px",
      center: true,
      selector: (row) => row.idPemilikUsaha,
    },
    {
      name: "Nama Nasabah",
      minWidth: "290px",
      center: true,
      selector: (row) => row.pemilikUsaha.namaPemilikUsaha,
    },
    {
      name: "NIK",
      minWidth: "190px",
      center: true,
      selector: (row) => (!row.pemilikUsaha.nik ? "-" : row.pemilikUsaha.nik),
    },
    {
      name: "No Hp",
      minWidth: "190px",
      center: true,
      selector: (row) =>
        !row.pemilikUsaha.noTelp ? "-" : row.pemilikUsaha.noTelp,
    },
    {
      name: "Tgl Lahir",
      minWidth: "190px",
      center: true,
      selector: (row) =>
        moment(row.pemilikUsaha.tglLahir).format("DD MMMM YYYY"),
    },

    {
      name: "Kategori Nasabah",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        row.pemilikUsaha.custType === "1"
          ? "Perorangan"
          : row.pemilikUsaha.custType === "2"
          ? "Badan Usaha"
          : "-",
    },
    {
      name: "Tipe Kunjungan",
      minWidth: "250px",
      center: true,
      selector: (row) => row.pemilikUsaha.tipeKunjungan,
      cell: (row) => {
        const statusStyle = getTypeKunjungan(row.pemilikUsaha.tipeKunjungan);
        const tampilanLabel = row.pemilikUsaha.tipeKunjungan;

        return (
          <div
            style={{
              fontWeight: statusStyle.fontWeight,
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              textTransform: "capitalize",
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {tampilanLabel}
          </div>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "200px",
      center: true,
      selector: (row) => row.action,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        height: 50, // override the row height
      },
    },
    headRow: {
      style: {
        minHeight: 35,
        backgroundColor: "#F8F8F8",
        // fontFamily: "Poppins",
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        minHeight: 50,
        fontWeight: "bold",
        fontSize: 14,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
    cells: {
      style: {
        minHeight: 50,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case "Progress":
        return {
          fontWeight: "bold",
          backgroundColor: "#FDE5DD",
          textColor: "#F85317",
        };
      case "Done":
        return {
          fontWeight: "bold",
          backgroundColor: "#BAD9FD",
          textColor: "#1776F1",
        };
      default:
        return {};
    }
  };

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  return (
    <>
      {debiturReducer.detailNasabahIdeb ? (
        <Container fluid>
          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Card.Title
                    as="h3"
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                    }}
                  >
                    Informasi Debitur
                  </Card.Title>

                  <Tab.Content>
                    <Card style={{ marginTop: 20, border: 0 }}>
                      <Row
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Col md={"4"}>
                          <InputGroup>
                            <Form.Control
                              style={{
                                paddingLeft: "10px",
                              }}
                              type="text"
                              value={searchText}
                              onChange={handleSearch}
                              onKeyDown={handleKeyDown}
                              placeholder="BAP - LOAN / Nama Pemilik Usaha"
                            />
                            <InputGroup.Append>
                              <InputGroup.Text
                                style={{ cursor: "pointer" }}
                                onClick={handleClearSearch}
                              >
                                <i class="fas fa-times"></i>
                              </InputGroup.Text>
                            </InputGroup.Append>
                          </InputGroup>
                        </Col>
                        <Col md={"8"}>
                          <Button
                            // variant="info"
                            style={{
                              fontSize: 16,
                              backgroundColor: "#00BFFF",
                              border: 0,
                              paddingTop: 10,
                              paddingBottom: 8,
                            }}
                            onClick={handleFilterChange}
                          >
                            <i class="fas fa-search"></i>
                          </Button>
                        </Col>
                      </Row>
                    </Card>
                  </Tab.Content>
                </Card.Header>

                <Card.Body>
                  {pending ? (
                    <div
                      className="loader-container"
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <div style={{ marginBottom: 20 }}>
                        <Hourglass
                          visible={true}
                          height="50"
                          width="50"
                          ariaLabel="hourglass-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                          colors={["#306cce", "#72a1ed"]}
                        />
                        {/* <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: 19,
                      }}
                    >
                      Loading ....
                    </p> */}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <DataTable
                        columns={colListIdeb}
                        data={listIdeb}
                        customStyles={customStyles}
                        paginationPerPage={totalPerHalaman}
                        progressPending={pending}
                      />
                      <div style={{ marginTop: 35 }}>
                        <Row
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Col>
                            <Row style={{ alignItems: "center" }}>
                              <div
                                style={{
                                  paddingRight: 0,
                                  marginLeft: 20,
                                  marginRight: 10,
                                }}
                              >
                                <label style={{ fontWeight: "bold" }}>
                                  Rows per page
                                </label>
                              </div>
                              <Col sm="3" style={{ paddingLeft: 0 }}>
                                <Select
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  name="Pilih Client"
                                  value={options.find(
                                    (option) => option.value === totalPerHalaman
                                  )}
                                  onChange={handlePageSizeChange}
                                  options={options}
                                  placeholder="Rows per page"
                                />
                              </Col>
                            </Row>
                          </Col>

                          <Col>
                            <ReactPaginate
                              forcePage={page}
                              containerClassName="paginations justify-content-end"
                              previousClassName="pages-items-containers"
                              previousLinkClassName="pages-links-labels"
                              nextClassName="pages-items-containers"
                              nextLinkClassName="pages-links-labels"
                              breakClassName="pages-items-containers"
                              pageCount={debiturReducer.listAllIdeb.totalPages}
                              pageRangeDisplayed={3}
                              marginPagesDisplayed={1}
                              pageLinkClassName="pages-links-labels"
                              pageClassName="pages-items-containers"
                              activeClassName="activees"
                              activeLinkClassName="activess"
                              nextLabel=" > "
                              previousLabel=" < "
                              initialPage={page}
                              disableInitialCallback={true}
                              onPageChange={(val) => {
                                setPage(val.selected);
                              }}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <DetailCalonNasabahIdeb value={idNasabah} data={sendVal} />
      )}
    </>
  );
}

export default InformasiDebitur;
